export default function LoyaltyProgram() {
  return (
    <>
      <h1 className="page-title">Loyalty Program</h1>
      <h2
        style={{
          textAlign: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      >
        This program is under construction. Soon it will be at your service!
      </h2>
    </>
  );
}
